// A short notice shown over any page when the gateway says "try again" (28 Oct, the sign-in build, items 1 and 2):
// it could not check the sign-in (503 AUTH_UNAVAILABLE), or this account sent too many requests (429 RATE_LIMITED).
// The request itself still fails to its caller as before; this only tells the person why, and keeps them signed in.
// Shown by components/RequestNotice.tsx, mounted once in BaseLayout. A fixed kind, never text from the server.

export type RequestNoticeKind = 'auth-unavailable' | 'rate-limited';

type Listener = (kind: RequestNoticeKind) => void;

const listeners = new Set<Listener>();

export const showRequestNotice = (kind: RequestNoticeKind): void => {
  listeners.forEach((listener) => listener(kind));
};

export const subscribeToRequestNotices = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
